<template>
    <div v-if="filters" class="c-search-page__filters">
        <div class="c-search-page__filter-section c-filters">
            <div class="c-filters__head">
                <div class="c-filters__head-info">
                    <h2 class="c-filters__title">Filter results</h2>
                    <div class="clear-filter" v-if="showClearFilter">
                        <a @click.prevent="clearFiltersButton" class="c-btn c-btn--small c-btn--clear-filters"
                        href="#clear-filters"><i class="fal fa-times" aria-hidden="true"></i> Clear</a>
                    </div>
                </div>
                <button class="c-filters__toggle c-btn c-btn--small c-btn--ghost" data-disclosure aria-controls="search-filters" aria-expanded="false">
                    <span>Show/Hide Filters</span>
                    <i class="fal fa-angle-down" aria-hidden="true"></i>
                </button>
            </div>
            <div class="c-filters__group" id="search-filters">
                <template v-if="loading">
                    <div class="c-filter-group">
                        <button class="c-btn c-btn--ghost c-filters__toggle-btn" data-disclosure aria-expanded="false" disabled>
                            <span>...</span> <i class="fal fa-angle-down" aria-hidden="true"></i>
                        </button>
                    </div>
                </template>
                <template v-for="taxonomy in filters">
                    <div class="c-filter-group">
                        <button class="c-btn c-btn--ghost c-filters__toggle-btn" data-disclosure :aria-controls="taxonomy.label" aria-expanded="false">
                            <span>{{ taxonomy.label }}</span> <i class="fal fa-angle-down" aria-hidden="true"></i>
                        </button>
                        <ul :id="taxonomy.label" class="c-filter-group__top-level" v-if="taxonomy.terms" hidden>
                            <li :key="term.id" class="" v-for="term in taxonomy.terms">
                                <Checkbox :checked="isChecked(term.slug)" :term="term"
                                            @checked="updateSelectedFilter"/>
                                <ul class="c-filter-group__second-level" v-if="term.children">
                                    <li :key="childTerm.id" class="" v-for="childTerm in term.children">
                                        <Checkbox :checked="isChecked(childTerm.slug)" :term="childTerm"
                                                    @checked="updateSelectedFilter"/>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkbox from "./Checkbox"
    import {EventBus} from "../event-bus"

    export default {
        name: "Filters",
        components: {
            Checkbox
        },
        props: ['area'],
        data() {
            return {
                filters: false,
                selectedFilters: [],
                showClearFilter: false,
                loading: true,
            }
        },
        mounted() {
            EventBus.$on('checked', this.updateSelectedFilter)
            EventBus.$on('url-params-updated', this.updateSelectedFilterFromUrlParams)
            EventBus.$on('active-filters', this.updateUiStateOfCheckboxes)
            EventBus.$on('clear-filters', this.clearFilters)
        },
        watch: {
            "area": function (val, oldVal) {
                if (val !== oldVal) {
                    this.fetchFilters()
                }
            }
        },
        methods: {
            clearFilters() {
                this.selectedFilters.forEach(filter => filter.state = false)
                this.showClearFilter = false
            },
            clearFiltersButton() {
                EventBus.$emit('clear-filters')
                this.clearFilters()
                EventBus.$emit('cleared-filters')
                this.updateResults()
            },
            fetchFilters() {
                // Only Works and Teaching use filters, so don't bother trying to load them for other areas
                if (['works', 'teach'].indexOf(this.area) === -1) {
                    this.filters = false
                    this.loading = false
                    EventBus.$emit('filters-populated', this.filters)      
                } else {
                    this.loading = true
                    this.filters = []
                    axios.get(window.wpAjax.url, {
                    params: {
                        action: 'basethemeFiltersRequest',
                        area: this.area
                    }
                    }).then(response => {
                        this.filters = (response.data.filters && response.data.filters.length !== 0) ? response.data.filters : false
                        EventBus.$emit('filters-populated', this.filters)
                        EventBus.$emit('update-active-works', this.selectedFilters)
                        this.loading = false
                    })
                }
            },
            isChecked(value) {
                return this.selectedFilters.some(element => {
                    return (element.value === value && element.state === true)
                })
            },
            isSelectedFilter() {
                return this.selectedFilters.some(element => element.state)
            },
            toggleClearFilter() {
                this.showClearFilter = this.isSelectedFilter()
            },
            updateResults() {
                this.toggleClearFilter()
                if (this.area === 'works') {
                    EventBus.$emit('update-active-works', this.selectedFilters)
                }
                EventBus.$emit('update-url-params', this.selectedFilters)
            },
            updateSelectedFilter(data) {
                const found = this.selectedFilters.some(element => element.value === data.value)

                if (found) {
                    this.selectedFilters.map(element => {
                        if (element.value === data.value) {
                            element.state = data.state
                        }
                        return element
                    })
                } else {
                    this.selectedFilters.push(data)
                }

                this.selectedFilters = this.selectedFilters.filter(element => {
                    return !((element.value === data.value) && element.state !== data.state);
                })

                this.updateResults()
            },
            updateSelectedFilterFromUrlParams(params) {
                const urlParams = Object.entries(params)
                let filters = []
                for (const [key, value] of urlParams) {
                    if (key !== 'q' && key !== 'area') {
                        if (Array.isArray(value)) {
                            value.forEach(element => {
                                filters.push({
                                    name: key,
                                    value: element,
                                    state: true
                                })
                            })
                        } else {
                            filters.push({
                                name: key,
                                value: value,
                                state: true
                            })
                        }
                    }
                }
                filters.forEach(element => this.updateSelectedFilter(element))
            },
            updateUiStateOfCheckboxes(activeFilters) {
                // As the works area pulls in remote results always enable all checkboxes
                if (this.area === 'works') {
                    this.$children.forEach(checkbox => {
                        checkbox.disabled = false
                    })
                    return;
                }

                if (false === activeFilters) { // if zero results returned deactivate all filters
                    this.$children.forEach(checkbox => {
                        checkbox.disabled = true
                    })
                } else if (activeFilters.length > 0) {
                    this.$children.forEach(checkbox => {
                        if (activeFilters.some(filter => checkbox.term.slug === filter.slug)) {
                            checkbox.disabled = false
                        } else {
                            checkbox.disabled = true
                        }
                    })
                } else {
                    this.$children.forEach(checkbox => {
                        checkbox.disabled = false
                    })
                }
            }
        },

    }
</script>

<style scoped>

</style>
